import axios from 'axios'

const axiosInstance = axios.create()

// PUT requests to `/api/parcel/{id}` and `/api/goods/{id}` must carry
// `version=v2`. Matches only the direct-id endpoints — sub-resources such as
// `/api/parcel/assembly/{id}` or `/api/goods/{id}/weight` are left untouched.
const VERSIONED_PUT_PATH = /\/api\/(?:parcel|goods)\/[^/?]+$/

axiosInstance.interceptors.request.use((config) => {
  if (config.method?.toLowerCase() === 'put' && config.url) {
    const [path] = config.url.split('?')
    if (VERSIONED_PUT_PATH.test(path) && !config.params?.version) {
      config.params = { ...config.params, version: 'v2' }
    }
  }
  return config
})

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error.response && error.response.data)
)

export default axiosInstance
